"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RapidStrikesAbilityHandler = exports.RapidStrikesActorAbilityFactory = exports.RapidStrikesAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Vulnerability_1 = require("../../core/effects/core/Vulnerability");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
class RapidStrikesAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.RapidStrikes;
        this.__typeName = "RapidStrikes";
    }
}
exports.RapidStrikesAbilityArgs = RapidStrikesAbilityArgs;
let RapidStrikesActorAbilityFactory = class RapidStrikesActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("RapidStrikes", "OneEnemies", 2);
    }
};
RapidStrikesActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("RapidStrikes")
], RapidStrikesActorAbilityFactory);
exports.RapidStrikesActorAbilityFactory = RapidStrikesActorAbilityFactory;
let RapidStrikesAbilityHandler = class RapidStrikesAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        const nAttacks = container.hasAttribute(ability.invokerId, "Charm_Warrior_0") ? 7
            : (0, Random_1.random)(2, 5);
        const targetIds = Array(nAttacks).fill(0).map(() => selectedEnemy);
        container.applyMultiAttack({
            sequence,
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            targets: targetIds.map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 30)
                ]
            })),
            onDamage(sequence, _target, _attack, damages) {
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new Vulnerability_1.VulnerabilityEffectArgs(damages.length),
                    duration: Duration_1.Duration.Turns(3),
                    sequence
                });
            },
        });
    }
};
RapidStrikesAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.RapidStrikes)
], RapidStrikesAbilityHandler);
exports.RapidStrikesAbilityHandler = RapidStrikesAbilityHandler;
